import { render, staticRenderFns } from "./GuidanceHelper.vue?vue&type=template&id=43198ff8&scoped=true&"
import script from "./GuidanceHelper.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GuidanceHelper.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./GuidanceHelper.vue?vue&type=style&index=0&id=43198ff8&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43198ff8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GuidanceBadge: require('/opt/atlassian/pipelines/agent/build/components/guidance/GuidanceBadge.vue').default})
